import { apiWithToken } from '../../systems/api';
import { API_URL } from '../../systems/globalContant';

export default {
	fetchInvoiceCodeChange: (params) => apiWithToken.get(API_URL.LIST_INVOICE_CODE_CHANGE, {params, singleRequest: true, loading: false}),
	getLogsInvoiceCodeChange: (id) => apiWithToken.get(API_URL.LOGS_INVOICE_CODE_CHANGE + id),
	changeApprovalRequestStatus: (approval_id, params) => apiWithToken.put(API_URL.LIST_INVOICE_CODE_CHANGE + `/${approval_id}`, {...params}, {loading: false})
};
